import { initializeApp } from "firebase/app";
import {
  createUserWithEmailAndPassword,
  getAuth,
  onAuthStateChanged,
  signInWithEmailAndPassword,
  signOut,
  setPersistence,
  browserSessionPersistence,
} from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Set up Firebase
const firebaseConfig = {
  apiKey: "AIzaSyDPJ2OFEb5JCtrB4fzHcV2MYrBP2CJEAfY",
  authDomain: "alpha-4a4e9.firebaseapp.com",
  projectId: "alpha-4a4e9",
  storageBucket: "alpha-4a4e9.firebasestorage.app",
  messagingSenderId: "849712445868",
  appId: "1:849712445868:web:33ae7ffa1de5020da6e209",
};

const app = initializeApp(firebaseConfig);

const auth = getAuth();
const db = getFirestore(app);

const storage = getStorage(app);

// Listen only for logged in state

export {
  app,
  auth,
  db,
  storage,
  onAuthStateChanged,
  signOut,
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  browserSessionPersistence,
  setPersistence,
};
